import accent from './accent';
import { lightBlue } from '@material-ui/core/colors';

const text = {
    alert: accent.orangeMain,
    error: accent.redDark,
    link: lightBlue[800],
    ok: accent.greenMain,
};
export default text;
